import { TableContext } from 'pages/PatientsPage';
import {
  AgeFilterChip,
  AlertFilterChip,
  CarePlanFilterChip,
  ConditionFilterChip,
  GenderFilterChip,
  ResetFilterChip,
  RiskFilterChip,
  ActivityFilterChip,
  PatientGroupFilterChip,
  CareTeamFilterChip
} from './FilterChips';
import { useContext, useMemo } from 'react';
import { Box } from '@mui/material';

export const PatientFilters = () => {
  const { filters } = useContext(TableContext);

  const hasAnyFilter = useMemo(
    () =>
      filters?.gender?.length ||
      filters?.startAge !== 0 ||
      filters?.endAge !== 130 ||
      filters?.risk?.length ||
      filters?.hasActiveAlert ||
      filters?.noActivity ||
      filters?.lastActivity?.max ||
      filters?.lastActivity?.min ||
      filters?.hasNoActiveAlerts ||
      filters?.condition?.length ||
      filters?.careTeamIds?.length ||
      filters?.activeRequestGroupPlanDefinitionIds ||
      filters?.completedRequestGroupPlanDefinitionIds ||
      filters?.hasNoRequestGroups ||
      filters?.patientGroupIds?.length,
    [filters]
  );
  if (!hasAnyFilter) return null;
  return (
    <Box display="flex" alignItems="center" flexWrap="wrap">
      <GenderFilterChip />
      <AgeFilterChip />
      <ActivityFilterChip />
      <RiskFilterChip />
      <AlertFilterChip />
      <ConditionFilterChip />
      <CareTeamFilterChip />
      <CarePlanFilterChip />
      <PatientGroupFilterChip />
      <ResetFilterChip />
    </Box>
  );
};
